// src/utils/extractErrorMessage.js

/**
 * error: objet d'erreur axios ou throw "custom"
 * t: fonction de traduction i18next (optionnelle)
 * defaultKey: clé i18n pour l'erreur générique
 */
export function extractErrorMessage(error, t, defaultKey = "errors.GENERIC_ERROR") {
  const translate = (key, params) => {
    if (typeof t === "function") {
      const result = t(key, params || {});
      // Si t retourne la clé elle-même (clé manquante), utiliser le fallback
      return result !== key ? result : null;
    }
    return null;
  };

  if (!error) {
    return translate(defaultKey) || "Une erreur inattendue est survenue.";
  }

  // 1) Cas axios : error.response.data.detail
  const detail = error?.response?.data?.detail;

  // a) Détail structuré { code, message, params }
  if (detail && typeof detail === "object" && detail.code) {
    const code = detail.code;
    const key = `errors.${code}`;
    const translated = translate(key, detail.params);
    if (translated) return translated;
    if (detail.message && typeof detail.message === "string") return detail.message;
    return translate(defaultKey) || "Une erreur inattendue est survenue.";
  }

  // b) Détail = string brut
  if (typeof detail === "string") return detail;

  // 2) Autres formats axios
  const msg =
    error?.response?.data?.message ||
    error?.message ||
    error?.toString?.();

  if (msg && typeof msg === "string") return msg;

  // 3) Fallback
  return translate(defaultKey) || "Une erreur inattendue est survenue.";
}
